//#region src/menu_section_designation.ts
let MenuSectionDesignation = /* @__PURE__ */ function(MenuSectionDesignation) {
	MenuSectionDesignation["Regular"] = "regular";
	MenuSectionDesignation["RecommendationPane"] = "recommendation-pane";
	MenuSectionDesignation["QuizBanner"] = "quiz-banner";
	MenuSectionDesignation["OrderHistory"] = "order-history";
	return MenuSectionDesignation;
}({});
//#endregion
export { MenuSectionDesignation };

//# sourceMappingURL=menu_section_designation.js.map